import { createCategoryUrl } from '~/components/CategoryBlocks/utils';
import type { Category } from '~/stores/CategoriesStore';

/** "See all" target of a home block: the catalog category it was built from. */
export const getBlockLink = (category: Category) => {
  const target = category.subcategory[0];

  return target ? createCategoryUrl({ id: target.id }) : undefined;
};

/** Facts of a zone collection, entered in the CMS as one line separated by dots, pipes or line breaks. */
export const splitFacts = (text: Nullable<string> | undefined) =>
  (text ?? '')
    .split(/\s*(?:·|\||\n)\s*/)
    .map((fact) => fact.trim())
    .filter(Boolean);
